import type {FetchBanksQuery, FetchBanksResponse} from '../../http';
import {fetchBanks} from '../../http';
import {useQuery, type UseQueryOptions} from 'react-query';

export function useFetchBanks(query?: FetchBanksQuery, options?: UseQueryOptions<FetchBanksResponse>) {
	return useQuery<FetchBanksResponse>({
		queryKey: ['banks', query ?? {}],
		queryFn: async ({signal}) => {
			const {data} = await fetchBanks(query, signal);

			return data;
		},
		staleTime: 5 * 60 * 1000,
		...options,
	});
}
